<template>
  <div class="color-picker-wrapper" v-click-outside="close">
    <div class="custom-ui-color-picker-label-row" v-if="label || info">
      <label :for="inputId" class="custom-ui-color-picker-label" v-if="label" v-text="label" />
      <ui-field-info :text="info" />
    </div>
    <div class="custom-ui-color-picker">
      <div class="chrome-picker">
        <Chrome v-model="colorModel" v-show="!disabled && isOpen" />
      </div>
      <div class="picker">
        <button
          type="button"
          class="selected-color"
          :style="{ background: colorModel.hex }"
          @click="isOpen = !isOpen"
        />
        <input
          :id="inputId"
          class="picker-input"
          type="text"
          v-model="colorModel.hex"
          :disabled="disabled"
          name="color"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Chrome } from '@ckpack/vue-color'
  import { onMounted, ref, useId, watch } from 'vue'

  const model = defineModel<string>()
  const { disabled, label, info } = defineProps<{
    disabled?: boolean
    label?: string
    info?: string
  }>()
  const emit = defineEmits(['hexPattern'])
  const inputId = useId()

  const isOpen = ref<boolean>(false)
  const hexPattern = ref<boolean>(false)
  const colorModel = ref<any>({
    hex: '#000000',
    source: 'hex',
  })

  onMounted(() => {
    if (model.value) {
      colorModel.value.hex = model.value
    }
  })

  watch(
    () => colorModel.value.hex,
    val => {
      if (/^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/.test(val)) {
        hexPattern.value = true
        model.value = val
      } else {
        hexPattern.value = false
      }
      emit('hexPattern', hexPattern.value)
    },
  )

  watch(model, val => {
    if (val) {
      colorModel.value.hex = val
    }
  })

  const close = () => {
    isOpen.value = false
  }
</script>

<style lang="scss" scoped>
  .color-picker-wrapper {
    @include flexible($direction: column, $align: flex-start);
    position: relative;
    .custom-ui-color-picker-label-row {
      @include flexible($align: center, $wrap: wrap);
      gap: 0.35rem;
      margin-bottom: 0.5rem;
      .custom-ui-color-picker-label {
        @include column-label($margin: 0);
        width: auto;
      }
    }
    .custom-ui-color-picker {
      border: 1px solid $border-color;
      border-radius: 5px;
      .chrome-picker {
        position: absolute;
        top: 100%;
        z-index: 99;
      }
      .picker {
        display: flex;
        padding: 0.5rem;
        .selected-color {
          width: 2.5rem;
          height: 2.5rem;
          display: flex;
          border-radius: 5px;
          margin-right: 0.5rem;
          border: 1px solid $border-color;
          cursor: pointer;
        }
        .picker-input {
          outline: none;
          border: none;
          background-color: $white;
        }
      }
    }
  }
</style>
